module.exports = __webpack_public_path__ + "static/media/atom.a898fd32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/HydrogenAtom/images/atom.svg
// module id = 40
// module chunks = 0